<template>
  <div class="aiSubTemplate">
    <DetailsNav></DetailsNav>
    <!-- header -->
    <div class="bannerBox">
      <div class="banner">
        <img src="./aiImg/banner_text.png" alt="" />
      </div>
    </div>
    <!-- end -->
    <!-- 导航 -->
    <!-- end -->
    <div class="divOffsetParent">
      <!-- 从原理到实践，一站式实现大模型开发应用 -->
      <div class="module1" id="scroll1">
        <div class="scrollCont" :class="{ scroll1Show: true }">
          <div class="title">
            <div>从原理到实践，一站式实现大模型开发应用</div>
            <div class="des">FROM PRINCIPLE TO PRACTICE</div>
          </div>
          <div class="content boxShow">
            <div class="items">
              <!-- <div class="item" v-for="(item, index) in module1" :key="index">
                <div class="cont">
                  <div class="itemTitle">{{ item.title }}</div>
                  <div class="itemContent">
                    <div>{{ item.content }}</div>
                    <div class="sketchImg">
                      <img
                        :src="item.img"
                        @click="amplifyImg(item.img)"
                        width="100%"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div> -->
              <div
                class="item"
                v-for="(item, index) in module1Tag2"
                :key="index"
              >
                <div class="cont">
                  <div class="itemTitle">{{ item.title }}</div>
                  <div class="itemContent">
                    <div>{{ item.content }}</div>
                    <div class="sketchImg" @click="amplifyImg(item.img)">
                      查看信息图
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 大模型应用开发行情：缺口巨大，待遇优厚 -->
      <div class="module1 module2" id="scroll2">
        <div class="scrollCont" :class="{ scroll2Show: scroll2Show }">
          <div class="title" style="padding-top: 70px;">
            <div>大模型能力体现</div>
            <div class="des" style="top: 53px">ABILITY EXPRESSION</div>
          </div>
          <div class="content">
            <div class="modHead">
              <span
                class="lab"
                :class="{ act: index == activeName }"
                v-for="(item, index) in actualCombatData"
                :key="index"
                @mouseover="handleClick(index)"
                >{{ item.title }}</span
              >
            </div>
            <div
              class="modCont"
              v-for="(item, index) in actualCombatData"
              :key="index"
              :label="item.title"
              :name="String(index)"
            >
              <div class="items" v-show="index == activeName">
                <div class="imgCont">
                  <img :src="item.url" />
                </div>
                <div class="cont">
                  <div
                    class="infoList"
                    v-for="(it, ind) in item.rightArr"
                    :key="ind"
                  >
                    <div class="icon">
                      <img src="./aiImg/icon_cheak@2x.png" />
                    </div>
                    <div class="title">{{ it.label }}</div>
                    <div class="paragraph">{{ it.content }}</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- </el-tabs> -->
          </div>
        </div>
      </div>
      <!-- 大模型应用开发行情：缺口巨大，待遇优厚 -->
      <div class="module1 module3" id="scroll3">
        <div class="scrollCont" :class="{ scroll3Show: scroll3Show }">
          <div class="title">
            <div>大模型应用开发行情：缺口巨大，待遇优厚</div>
            <div class="des">BIG GAP GOOD DEAL</div>
          </div>
          <div class="content">
            <img src="./aiImg/pic-rgzn.png" alt="" />
            <img src="./aiImg/pic-sfgcs.png" alt="" />
          </div>
        </div>
      </div>
      <!-- end -->
      <!-- 技术架构 - start -->
      <div class="module1 module4" id="scroll4">
        <div class="scrollCont" :class="{ scroll5Show: scroll4Show }">
          <div class="title">
            <div>课程覆盖70%的国内外主流大模型，领先全网</div>
            <div class="des">COURSE COVERAGE</div>
          </div>
          <div class="desc content">
            在国内，截至2023年8月31日，多家大模型企业和机构正式宣布其服务已经上线，并向全社会开放。目前，百度、智谱、百川、字节、商汤、中科院（紫东太初）等8个企业和机构的大模型名列第一批备案名单，它们可以正式上线并向公众提供服务。
          </div>
          <div class="checkAllCourse" @click="amplifyImg(bigModImg)" >查看大模型进阶树</div>
          <div class="itemBox">
            <div
              class="items"
              v-for="(item, index) in module4Data"
              :key="index"
            >
              <div class="icon"><img :src="item.icon" alt="" /></div>
              <div class="title">{{ item.title }} <span v-if="item.tag">课程已涵盖</span></div>
              <div class="item" v-for="(it, ind) in item.content" :key="ind">
                <div class="cont">
                  <div class="tit">{{ it.title }}</div>
                  <div class="des">{{ it.desc }}</div>
                  <!-- <div class="more">阅读全文</div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end -->

      <!-- 学完即可全面掌握大模型微调核心技能 -->
      <div class="moduleIn" id="scroll5">
        <div class="scrollCont" :class="{ scroll5Show: scroll5Show }">
          <div class="topTit">
            <div>学完即可全面掌握大模型微调核心技能</div>
            <div class="des">CORE SKLL</div>
          </div>
          <div class="contBox">
            <div class="TruePlanCont">
              <div class="TruePlanBox">
                <div class="TruePlanLeft">
                  <div
                    :class="{ item: true, active: TruePlanSt === index }"
                    @click="() => (TruePlanSt = index)"
                    v-for="(item, index) in TruePlanDataes"
                    :key="index"
                  >
                    <div class="title">{{ item.title }}</div>
                    <div class="desc">{{ item.subTitle }}</div>
                  </div>
                </div>
                <div class="TruePlanRight">
                  <div
                    class="itemCont"
                    :class="{
                      scrollShow: TruePlanDataes[TruePlanSt].content.length > 9,
                    }"
                  >
                    <div
                      class="list"
                      v-for="(item, index) in TruePlanDataes[TruePlanSt]
                        .content"
                      :key="index"
                      @mouseover="() => (showDescInd = index)"
                      @mouseout="() => (showDescInd = '')"
                    >
                      <!-- <div class="tit">{{item.title}}</div>
                          <div class="desc" :title="item.desc" >{{cutstr(item.desc, 28)}}</div>
                          <div class="showAll" v-show="showDescInd === index">{{item.desc}}</div> -->
                      <el-popover
                        placement="top-start"
                        width="200"
                        trigger="hover"
                        :content="item.desc"
                      >
                        <div slot="reference">
                          <div class="tit">{{ item.title }}</div>
                          <div class="desc">{{ cutstr(item.desc, 38) }}</div>
                        </div>
                      </el-popover>
                    </div>
                  </div>
                </div>
              </div>
              <div class="retouch">
                <img src="./aiImg/ret_play.png" width="62" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end -->
      <!-- 课程大纲 - start -->
      <div class="classList" id="scroll6">
        <div class="scrollCont" :class="{ scroll6Show: scroll6Show }">
          <modelTitl
            v-if="classInfo"
            :title="classInfo.classTitle"
            subTitle="九种主流大模型一网打尽，五大热门行业应用全覆盖"
            :enTag="classInfo.classEnTitle"
          ></modelTitl>
          <CourseCards :data="courseBaseData"></CourseCards>
          <div class="subTit">课程涵盖大模型包括：ChatGPT、ChatGLM、LLaMA、BLOOM、BERT、星火(科大讯飞)、盘古(华为)、文心一言(百度)、通义千间(阿里巴巴)</div>
          <div class="checkAllCourse" @click="goDetailPage('https://www.boxuegu.com/live/detail-10046.html?utm_source=sygg')">查看完整大纲章节</div>
          <CourseItem :data="courseListData" type="1"></CourseItem>
          <div class="adv">
            <img src="./aiImg/banner-wenzi.png" width="580" alt="" />
          </div>
          <CourseItem :data="courseListData2" type="2"></CourseItem>
        </div>
      </div>
      <!-- 课程大纲 - end -->
      <!-- 讲师风采 - start -->
      <div
        class="teacherCont"
        id="scroll7"
        v-if="teacherInfo && teacherList"
        :style="{
          'background-color': teacherInfo.teachBgColor,
          'background-image': `url(${
            teacherInfo.teachBgImg && teacherInfo.teachBgImg.length > 0
              ? teacherInfo.teachBgImg[0].url
              : ''
          })`,
        }"
      >
        <div class="scrollCont" :class="{ scroll7Show: scroll7Show }">
          <modelTitl
            :title="teacherInfo.teachModleTitle"
            subTitle=""
            :enTag="teacherInfo.TeachEnTitle"
          ></modelTitl>
          <common-techer-display-widge
            :imgs="teacherList"
            v-if="teacherList.length > 0"
          ></common-techer-display-widge>
        </div>
      </div>
    </div>
    <img
      src="https://pip.itcast.cn/uploads/d65f35c00d8945dc8fece3f3156e98ee.png"
      width="100%"
      alt=""
    />
    <!-- 讲师风采 - end -->
    <bottom-widge></bottom-widge>
    <MenuAdd ref="editMenu"></MenuAdd>
    <el-dialog
      :visible.sync="dialogVisible"
      width="60% !important"
      class="dialogCont"
    >
      <div class="amplifyImg">
        <img width="100%" :src="amplifyImgUrl" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { pythonObject } from "../../../../gqlapi/AiDetail.js";
import DetailsNav from "./../../../components/detailsNav.vue";
// import studyPathWidge from "./components/javaStudyPathWidge.vue";
import commonTecherDisplayWidge from "./components/techerDisplayWidge";
import modelTitl from "./components/modelTitle.vue";
import CourseCards from "./components/CourseCards.vue";
import CourseItem from "./components/CourseItem.vue";
import bottomWidge from "./../../../components/bottomWidge";
import MenuAdd from "./../../../components/video";
import { CutString } from "./../../../../utils/tools";

import bigModImg from "./aiImg/bigModImg.png";

import mdImg1 from "./aiImg/mode1-1.png";
import mdImg2 from "./aiImg/mode1-2.png";
import mdImg3 from "./aiImg/mode1-3.png";
import mdImg4 from "./aiImg/mode1-4.png";
import mdImg5 from "./aiImg/mode1-5.png";
import mdImg6 from "./aiImg/mode1-6.png";

import aiIconImg1 from "./aiImg/mode2-1.png";
import aiIconImg2 from "./aiImg/mode2-2.png";
import aiIconImg3 from "./aiImg/mode2-3.png";
import aiIconImg4 from "./aiImg/mode2-4.png";
import aiIconImg5 from "./aiImg/mode2-5.png";
import aiIconImg6 from "./aiImg/mode2-6.png";
import aiIconImg7 from "./aiImg/mode2-7.png";

import Icon1 from "./aiImg/openai.png";
import Icon2 from "./aiImg/meta.png";
import Icon3 from "./aiImg/baidu.png";
import Icon4 from "./aiImg/aiGLM.png";
import Icon5 from "./aiImg/ai-ali.png";
import Icon6 from "./aiImg/nvidia.png";
import Icon7 from "./aiImg/icon-st.png";
import Icon8 from "./aiImg/huawei.png";
import Icon9 from "./aiImg/google.png";

import source1 from "./aiImg/source1.png";
import source2 from "./aiImg/source2.png";
import source3 from "./aiImg/source3.png";
import source4 from "./aiImg/source4.png";

import courseIcon1 from "./aiImg/courseIcon1.png";
import courseIcon2 from "./aiImg/courseIcon2.png";
import courseIcon3 from "./aiImg/courseIcon3.png";
import courseIcon4 from "./aiImg/courseIcon4.png";
import courseIcon5 from "./aiImg/courseIcon5.png";
import courseIcon6 from "./aiImg/courseIcon6.png";

export default {
  components: {
    DetailsNav,
    bottomWidge,
    modelTitl,
    CourseCards,
    CourseItem,
    // studyPathWidge,
    commonTecherDisplayWidge,
    MenuAdd,
  },
  data() {
    return {
      bigModImg: bigModImg,
      topImg: "",
      butImg: "",
      amplifyImgUrl: "",
      showRwm: 99,
      bannerDeSt: false,
      platIsOpen: true,
      baseData: null,
      bannerInfo: null,
      platformInfo: null,
      platformData: null,
      sceneInfo: null,
      sceneBgColor: null,
      sceneBgImg: null,
      modelData: [], // 功能模块、技术架构
      programData: null, // 解决方案
      classData: null, // 课程大纲
      teacherInfo: null,
      teacherList: null, //讲师列表
      classInfo: null,
      programState: 0,
      scrollState: "add",
      videoUrl: "",
      acttionInfo: null,
      topImgSt: true,
      objName: "",
      routerLink: "",
      scroll1Show: false,
      scroll2Show: false,
      scroll3Show: false,
      scroll4Show: false,
      scroll5Show: false,
      scroll6Show: false,
      scroll7Show: false,
      bannerLabItems: [],
      advantageModleTitle: "", //项目优势
      advantageList: [], //项目优势列表
      funIntroductionTitle: "", //功能介绍
      funIntroductionList: [], //功能介绍列表
      sceneModleTitle: "", //应用场景
      dialogVisible: false,
      flowData: [
        { index: 0, desc: "项目优势" },
        { index: 1, desc: "应用场景" },
        { index: 2, desc: "功能介绍" },
        { index: 3, desc: "技术架构" },
        { index: 4, desc: "课程大纲" },
        { index: 5, desc: "研发团队" },
      ],
      baseHeight: 1000,
      localItemIndex: 0,
      module1: [
        {
          title: " 大模型架构类别",
          content:
            "大模型的主要类别架构：encoder_only、decoder_only、encoder_decoder，掌握LLaMA、ChatGLM、BLOOM等主流开源大模型的架构及原理等。",
          img: mdImg1,
        },
        {
          title: " 大模型高效微调方法",
          content:
            "掌握面向大模型的Prompt_Tuning方法，包括In-Context learning、Instruction-Tuning、Chain-of-Thought、PEFT（Adapter-Tuning、LoRA、Prefix_Tuning等）等方式。",
          img: mdImg2,
        },
        {
          title: " 主流开源大模型的原理挖掘",
          content:
            "详细剖析从GPT、GLM、LLaMA、ChatGLM到国内热门Baichuan、Qwen、华为盘古等认知大模型技术原理",
          img: mdImg3,
        },
        {
          title: " 经典Prompt最佳实践",
          content:
            "通过prompt baesed learing方式，让上游的预训练模型在少量样本标注数据的情况下比较好的完成下游的任务。",
          img: mdImg4,
        },
        {
          title: " 企业级大模型平台",
          content:
            "一站式企业级大模型平台，提供先进的生成式AI生产及应用全流程开发工具链，包含有百度千帆大模型平台、讯飞大模型微调平台等",
          img: mdImg5,
        },
        {
          title: " 大模型的云端算力支持",
          content:
            "以腾讯云HAI平台为例，提供澎湃算力，即开即用。以应用为中心，匹配GPU云算力资源，助力中小企业及开发者快速部署LLM、AI作画、数据科学等高性能应用。",
          img: mdImg6,
        },
      ],
      module1Tag2:  [
        {
          title: " 大模型架构类别",
          content:
            "大模型的主要类别架构：encoder_only、decoder_only、encoder_decoder，掌握LLaMA、ChatGLM、BLOOM等主流开源大模型的架构及原理等。",
          img: mdImg1,
        },
        {
          title: " 大模型高效微调方法",
          content:
            "掌握面向大模型的Prompt_Tuning方法，包括In-Context learning、Instruction-Tuning、Chain-of-Thought、PEFT（Adapter-Tuning、LoRA、Prefix_Tuning等）等方式。",
          img: mdImg2,
        },
        {
          title: " 主流开源大模型的原理挖掘",
          content:
            "详细剖析从GPT、GLM、LLaMA、ChatGLM到国内热门Baichuan、Qwen、华为盘古等认知大模型技术原理",
          img: mdImg3,
        },
        {
          title: " 经典Prompt最佳实践",
          content:
            "通过prompt baesed learing方式，让上游的预训练模型在少量样本标注数据的情况下比较好的完成下游的任务。",
          img: mdImg4,
        },
        {
          title: " 企业级大模型平台",
          content:
            "一站式企业级大模型平台，提供先进的生成式AI生产及应用全流程开发工具链，包含有百度千帆大模型平台、讯飞大模型微调平台等",
          img: mdImg5,
        },
        {
          title: " 大模型的云端算力支持",
          content:
            "以腾讯云HAI平台为例，提供澎湃算力，即开即用。以应用为中心，匹配GPU云算力资源，助力中小企业及开发者快速部署LLM、AI作画、数据科学等高性能应用。",
          img: mdImg6,
        },
      ],
      activeName: "0",
      actualCombatData: [
        {
          url: aiIconImg1,
          title: "多模交互",
          rightArr: [
            {
              label: "多模交互",
              content:
                "上传图片素材，大模型完成识别理解，返回关于图片的准确描述",
            },
            {
              label: "视觉问答",
              content: "围绕上传图片素材，响应用户的问题，大模型完成回答",
            },
            {
              label: "多模生成",
              content: "根据用户的描述，生成符合期望的合成音频和视频",
            },
            {
              label: "虚拟人视频",
              content: "描述期望的视频内容，整合AI虚拟人，快速生成匹配视频",
            },
          ],
        },
        {
          url: aiIconImg2,
          title: "代码生成",
          rightArr: [
            {
              label: "代码生成",
              content:
                "智能生成单行或函数级代码建议；根据注释、函数名自动生成代码",
            },
            {
              label: "代码解释",
              content:
                "类、函数及其作用逐一详解；支持逐行代码注释；学习海量范式，快速精准解读",
            },
            {
              label: "代码纠错",
              content:
                "精准定位拼写、语法、逻辑错误；新老代码比较，支持一键修改",
            },
            {
              label: "单元测试",
              content:
                "选中代码，一键生成单测用例；多主流单元测试框架；智能生成单元测试数据",
            },
          ],
        },
        {
          url: aiIconImg3,
          title: "文本生成",
          rightArr: [
            {
              label: "商业文案",
              content: "根据用户要求，创作具有吸引力与情感共鸣的商业文案",
            },
            {
              label: "营销方案",
              content: "根据描述，创作多种形式的营销方案",
            },
            {
              label: "英文写作",
              content: "使用英文完成多风格多任务的的长写作任务",
            },
            {
              label: "新闻通稿",
              content: "根据新闻要素，创作严谨详实的新闻通稿",
            },
          ],
        },
        {
          url: aiIconImg4,
          title: "语言理解",
          rightArr: [
            {
              label: "机器翻译",
              content:
                "翻译多种语言的文字，包括英语、中文、法语、德语、西班牙语等常用语种",
            },
            {
              label: "文本摘要",
              content: "根据文本提取简洁而准确的摘要，快速理解文章的核心观点",
            },
            {
              label: "语法检查",
              content: "检查语法错误并提供正确的语法建议，使写作更加规范与专业",
            },
            {
              label: "情感分析",
              content:
                "分析文本中的情感色彩，如正面、负面或中性，更好了解内容观点和态度",
            },
          ],
        },
        {
          url: aiIconImg5,
          title: "知识问答",
          rightArr: [
            {
              label: "生活常识",
              content: "提供有关日常生活的知识，如饮食、运动、旅游等方面的建议",
            },
            {
              label: "工作技能",
              content:
                "提供工作方面的知识，如沟通技巧、时间管理技巧、团队协作等方面的建议",
            },
            {
              label: "医学知识",
              content:
                "提供基本的健康保健知识以及疾病预防、诊断和治疗方面的建议",
            },
            {
              label: "历史人文",
              content:
                "提供有关历史事件、文化传承、名人故事、名言警句等方面的文案",
            },
          ],
        },
        {
          url: aiIconImg6,
          title: "逻辑推理",
          rightArr: [
            {
              label: "思维推理",
              content:
                "通过分析问题的前提条件和假设来推理出答案或解决方案，给出新的想法和见解",
            },
            {
              label: "科学推理",
              content:
                "使用已有的数据和信息进行推断、预测和验证等科学研究中的基本任务",
            },
            {
              label: "常识推理",
              content:
                "在进行对话交流时，运用已有的常识知识来分析、解释和回应用户的提问或需求",
            },
          ],
        },
        {
          url: aiIconImg7,
          title: "数理计算",
          rightArr: [
            {
              label: "方程求解",
              content: "包括一元二次方程、二元一次方程、三元一次方程等等",
            },
            {
              label: "几何问题",
              content:
                "平面几何（如直线、圆、三角形等的性质）和立体几何（如体积、表面积、投影等）",
            },
            {
              label: "微积分",
              content:
                "处理导数、积分等微积分相关的问题，涉及基本概念如极限、连续性、导数等",
            },
            {
              label: "概率统计",
              content: "涉及随机变量、概率分布、假设检验等方面的内容",
            },
          ],
        },
      ],
      module4Data: [
      {
          icon: Icon4,
          title: "智谱AI",
          tag: true,
          content: [
            {
              title: "GLM",
              desc:
                "一个基于自回归填空的通用预训练框架，通过在一个统一的框架中同时学习双向和单向的注意力机制。",
              url: "",
            },
            {
              title: "GLM-130B",
              desc:
                "GLM-130B 是一个开源开放的双语（中文和英文）双向稠密模型，拥有 1300 亿参数，模型架构采用通用语言模型（GLM）。",
              url: "",
            },
            {
              title: "ChatGLM-6B",
              desc:
                "ChatGLM-6B 是一个开源的、支持中英双语问答的对话语言模型，并针对中文进行了优化。",
              url: "",
            },
          ],
        },
        {
          icon: Icon5,
          title: "阿里",
          tag: true,
          content: [
            {
              title: "M6",
              desc:
                "2021年6月，阿里巴巴联合清华大学发表了一项新研究，提出了参数规模达到1000亿的中文预训练模型，M6是当时最大规模的中文多模态预训练模型。",
              url: "",
            },
            {
              title: "通义千问",
              desc:
                "2023年4月，阿里发布了「通义千问」，而就在前几天，阿里再次推出以通义千问70亿参数模型Qwen-7B为基座语言模型：Qwen-VL，支持图文输入，具备多模态信息理解能力，还新增了视觉定位、图像中文字理解等能力。",
              url: "",
            },
          ],
        },
        {
          icon: Icon8,
          title: "华为",
          tag: true,
          content: [
            {
              title: "PanGu-Alpha",
              desc:
                "华为开发了一种与 OpenAI 的 GPT-3 相当的中文模型，称为 PanGu-Alpha。该模型基于 1.1 TB 的中文资源。",
              url: "",
            },
          ],
        },
        {
          icon: Icon2,
          title: "Meta",
          tag: true,
          content: [
            {
              title: "Claude",
              desc:
                "Claude是一个由先进的自然语言处理驱动的基于AI的对话助手。",
              url: "",
            },
            {
              title: "BlenderBot-3",
              desc:
                "BlenderBot3是基于MetaAI公开提供的OPT-175B语言模型而构建的。",
              url: "",
            },
          ],
        },
        {
          icon: Icon9,
          title: "Google",
          tag: true,
          content: [
            {
              title: "LaMDA",
              desc:
                "LaMDA是一系列专门用于对话的基于Transformer的模型。这些模型拥有多达1370亿个参数，并使用1.56万亿个公开对话数据进行训练。",
              url: "",
            },
            {
              title: "Google Gemini",
              desc:
                "Gemini在大语言模型研究和开发中广泛使用的 32 项学术基准中，Gemini Ultra 的性能有 30 项都超过了目前最先进的水平。",
              url: "",
            },
          ],
        },
        {
          icon: Icon1,
          title: "Open AI",
          tag: true,
          content: [
            {
              title: "ChatGPT",
              desc:
                "ChatGPT是由GPT-3语言模型驱动的开源聊天机器人。它能够与用户进行自然语言对话交流。",
              url: "",
            },
          ],
        },
        {
          icon: Icon6,
          title: "NVIDIA",
          tag: false,
          content: [
            {
              title: "Megatron-Turing NLG",
              desc:
                "Megatron-Turing自然语言生成（MT-NLG）模型是一个基于Transformer的语言模型，拥有5300亿个参数。",
              url: "",
            },
          ],
        },
        {
          icon: Icon7,
          title: "商汤",
          tag: false,
          content: [
            {
              title: "日日新",
              desc:
                "2023年4月商汤推出大模型 “日日新”，包括自然语言处理模型 “商量”、文生图模型 “秒画” 等应用。",
              url: "",
            },
          ],
        },
        {
          icon: Icon3,
          title: "百度",
          tag: true,
          content: [
            {
              title: "Ernie 3.0 Titan",
              desc:
                "由百度和鹏程实验室联合发布，它有 260B 个参数，擅长自然语言理解和生成。",
              url: "",
            },
            {
              title: "Ernie Bot",
              desc:
                "Ernie Bot 是一种人工智能语言模型，能够进行语言理解、语言生成和文本到图像的生成。",
              url: "",
            },
          ],
        },
        
      ],
      TruePlanSt: 0,
      TruePlanDataes: [
        {
          title: "核心技能",
          subTitle: "技术的万能钥匙，一个技能解决n多业务问题",
          content: [
            {
              title: "夯实理论基础",
              desc:
                "掌握大语言模型的基本思想，了解语言模型的主要方法以及常见语言模型的评价指标。",
            },
            {
              title: "开源大模型原理剖析",
              desc:
                "了解大模型的主要类别架构：encoder_only、decoder_only、encoder_decoder，掌握LLaMA、ChatGLM、BLOOM等主流开源大模型的架构及原理等。",
            },
            {
              title: "全方位大模型微调手段",
              desc:
                "掌握面向大模型的Prompt_Tuning方法，包括In-Context learning、Instruction-Tuning、Chain-of-Thought、PEFT（Adapter-Tuning、LoRA、Prefix_Tuning等）等方式",
            },
            {
              title: "经典Prompt任务实战经验积累",
              desc:
                "玩转PET、P-Tuning等不同prompt方式实现多文本分类任务的应用实现，对比分析不同微调方式的优缺点及使用场景。",
            },
            {
              title: "大模型开发应用实现",
              desc:
                "基于zero-shot方式实现ChatGLM模型进行多任务应用的实现，包括但不限于：文本分类、文本匹配、信息抽取等任务。基于高效prompt-tuning方法实现ChatGLM大模型完成信息抽取 + 文本分类混合任务的企业应用实践。",
            },
            {
              title: "大模型开发框架应用",
              desc:
                "掌握LangChain核心组件构成及原理，基于ChatGLM构建本地知识库的问答系统，为企业提供更有价值的解决方案。",
            },
            {
              title: "腾讯云Hai平台构建StableDiffusion图像生成项目",
              desc:
                "从图像生成背景、生成方法的介绍出发，进行sd stablediffusion相关模型训练，最终部署至腾讯hai平台，使学员掌握图像生成的相关技术，从而完成个人专属图像生成大模型的应用。",
            },
            {
              title: "基于阿里PAI平台的大模型实战",
              desc:
                "介绍主流开源LLM技术原理、模型特点及开发流程，完成Llama2-13B部署、完成ChatGLM-6B部署以及基于LangChain搭建问答知识库，基于Llama2搭建聊天机器人。",
            },
            {
              title: "基于星火大模型微调实战",
              desc:
                "在百度智能云千帆大模型平台上，构建基于文心一言的本地知识库QA问答项目、基于千帆模型使用prompt应用开发项目、微调部署第三方大模型项目；让学员掌握整个NLP领域的数据服务、大模型训练、大模型管理、大模型服务、Prompt工程的企业级实战开发技巧。",
            },
            {
              title: "基于百度千帆大模型平台微调实战",
              desc:
                "通过微调百度千帆大模型平台上的预训练模型，我们着眼于增强文本摘要的功能，使其更符合特定领域或任务的需求。在这个实战项目中，我们将从数据准备、模型微调、发布模型在线服务全方位展开，致力于在尽量减少标注数据的情况下提升Llama-2-7b在文本摘要任务上的性能。",
            },
            {
              title: "基于GPT-2预训练模型完成聊天机器人项目应用实战",
              desc:
                "基于GPT-2预训练模型完成聊天机器人项目实战：项目业务来自于泛电商场景，从 数据准备、数据处理、模型搭建、模型训练验证到模型预测（人机交互），掌握基于预训练模型实现聊天机器人搭建的原理及过程，实现从0到1搭建类似ChatGPT的聊天机器人。",
            },
          ],
        },
      ],
      courseBaseData: [
        {
          title: "大模型项目系统设计",
          desc:
            "大模型课程背景<br /> 大模型开发流程 ",
        },
        {
          title: "大模型<br />提示词工程实战",
          desc:
            "基于开源主流大模型实现文本分类、信息抽取等任务的Prompt设计，进而解决相关业务问题 (金融)",
          objList: [{name:"金融行业动态风向评估", icon: courseIcon1}],
        },
        {
          title: "大模型<br />平台应用实战",
          desc:
            "基于企业大模型平台完成文生图模型训练实现虚拟试衣的应用(社交)",
          objList: [{name:"社交领域虚拟试衣系统", icon: courseIcon2}],
        },
        {
          title: "大模型<br />知识库应用实战",
          desc:
            "基于LangChain大模型开发工具，搭建物流行业信息本地知识库问答系统 (物流)",
          objList: [{name:"物流咨询智能问答系统", icon: courseIcon3}],
        },
        {
          title: "大模型<br />微调实战",
          desc:
            "基于大模型微调技术，实现多业务领域的应用，如构建智能问答系统、评价决策系统等 (大健康、新零售、新媒体)",
          objList: [
            {name:"大健康行业智能问诊系统", icon: courseIcon4},
            {name:"新零售行业评价决策系统", icon: courseIcon5},
            {name:"新媒体行业评论智能分类与信息抽取系统", icon: courseIcon6}],
        },
      ],
      courseListData: [
        {
          modTit: "大模型项目系统设计",
          courseCont: [
            {
              title: "第一阶段：大模型背景知识",
              classtitle: "课程内容",
              studytitle: "学习收获",
              classList: [
                "1.什么是大模型",
                "2.语言模型的主要方法",
                "3.学完本阶段课程主要收获",
              ],
              study: [
                "1.理解什么是大模型",
                "2.掌握目前主要的语言模型类型",
                "3.掌握语言模型的评价指标",
              ],
            },
            {
              title: "第二阶段:  大模型开发流程",
              classtitle: "课程内容",
              studytitle: "学习收获",
              classList: [
                "1.大模型开发项目流程及团队构成",
                "2.模型构建",
                "3.模型评估",
                "4.模型部署和上线",
              ],
              study: [
                "1.了解目前LLM大语言模型的主要类别架构",
                "2.掌握大模型开发的流程",
                "3.掌握主流的对中文支持较好的大模型"
              ],
            }
          ],
        },
        {
          modTit: "大模型提示词工程实战",
          courseCont: [
            {
              title: "第三阶段：金融行业动态风向评估",
              classtitle: "基于什么技术解决什么问题",
              classList: [
                "基于Zero-shot方式的大模型实战，包括文本分类，信息抽取，文本匹配等任务",
              ],
              studytitle: "学习收获",
              study: [
                "1.掌握基于Zero-shot方式实现ChatGLM模型进行文本分类",
                "2.掌握基于Zero-shot方式实现ChatGLM模型进行信息抽取",
                "3.掌握基于Zero-shot方式实现ChatGLM模型进行文本匹配",
              ],
            },
          ],
        },
        {
          modTit: "企业级大模型平台应用实战",
          courseCont: [
            {
              title:
                "第四阶段：社交领域虚拟试衣系统",
              classtitle: "基于什么技术解决什么问题",
              classList: [
                "基于解决图像真实性差，面料质感无法呈现，颜色还原度低，尺码不匹配等问题",
              ],
              studytitle: "学习收获",
              study: [
                "1.掌握Stable Diffusion文生图Lora模型微调实现虑拟上装",
                "2.掌握Llama2-7B-Chat大模型的轻量化LoRA微调及量化",
              ],
            }
          ],
        },
        {
          modTit: "大模型知识库应用实战",
          courseCont: [
            {
              title:
                "第五阶段：物流行业信息咨询智能问答系统",
              classtitle: "基于什么技术解决什么问题",
              classList: ["基于LangChain+ChatGLM实现本地知识库问答机器人搭建"],
              studytitle: "学习收获",
              study: [
                "1.掌握LangChain工具的基本使用方式",
                "2.理解向量知识库以及实现知识库的技术原理",
                "3.掌握LangChain+ChatGLM-6B实现基于本地知识库问答的机器人搭建方法",
              ],
            },
          ],
        },
        {
          modTit: "大模型微调实战",
          courseCont: [
          {
              title:
                "第六阶段：大健康行业智能问诊系统",
              classtitle: "基于什么技术解决什么问题",
              classList: ["基于GPT2预训练模型微调，解决机器人自动QA问答，进而取代人工，节省人工成本"],
              studytitle: "学习收获",
              study: [
                "1.掌握基于预训练模型实现聊天机器人搭建的原理及过程",
                "2.实现从0到1搭建类似ChatGPT的聊天机器人",
              ],
            },
            {
              title:
                "第七阶段：新零售行业评价决策系统",
              classtitle: "基于什么技术解决什么问题",
              classList: ["基于基于BERT+PET/P-Tuning方式实现小样本多分类任务"],
              studytitle: "学习收获",
              study: [
                "1.掌握基于预训练模型+PET微调方式的小样本分类方法",
                "2.掌握基于预训练模型+P-Tuning微调方式小样本分类方法",
                "3.理解Prompt-Tuning微调方法带来的优势",
              ],
            },
            {
              title:
                "第八阶段：新媒体行业评论智能分类与信息抽取系统",
              classtitle: "基于什么技术解决什么问题",
              classList: ["基于ChatGLM-6B+LoRA微调（P-tuning）实现信息抽取+文本分类的多任务", ],
              studytitle: "学习收获",
              study: [
                "1.掌握基于ChatGLM-6B大模型进行Lora微调的方式",
                "2.掌握基于ChatGLM-6B大模型进行P-Tuning微调的方式",
                "3.掌握基于LLM进行混合任务开发应用的实现过程",
                "4.掌握基于Flask框架实现API接口开发和应用",
              ],
            },
          ],
        },
      ],
      courseListData2: [
        {
          modTit: "文心一言系列大模型课程",
          url: source1,
          courseCont: [
            {
              tit: "大模型开发基础",
              list: [
                "1.文心一言大模型应用与实战",
                "2.百度千帆大模型微调平台实战",
                "3.基于PaddlePaddle框架深度学习应用开发",
              ],
            },
            {
              tit: "大模型项目开发",
              list: [
                "1.基于ERNIE Bot 模型的车型识别项目实战",
                "2.基于ERNIE Bot 模型的信息抽取项目实战",
                "3.百度千帆大模型微调平台实战",
              ],
            },
          ],
        },
        {
          modTit: "讯飞星火大模型系列课程",
          url: source2,
          courseCont: [
            {
              tit: "大模型开发基础",
              list: [
                "1.星火大模型入门",
                "2.星火大模型原理挖掘",
                "3.Python调用星火大模型API",
                "4.基于星火大模型实现小样本自训练实战",
              ],
            },
            {
              tit: "大模型项目开发",
              list: ["星火大模型综合案例"],
            },
          ],
        },
        {
          modTit: "StableDifusion多模态大模型课程",
          url: source3,
          courseCont: [
            {
              tit: "大模型开发基础",
              list: [
                "1.图像⽣成背景介绍",
                "2.StableDiffusion原理",
                "3.腾讯云StableDiffusion应⽤实践",
                "4.腾讯云在业界中应⽤",
              ],
            },
            {
              tit: "大模型项目开发",
              list: ["StableDiffusion多模态大模型文生图创作辅助系统"],
            },
          ],
        },
        {
          modTit: "阿里云ACP人工智能认证课程",
          url: source4,
          courseCont: [
            {
              tit: "第1章：人工智能基础",
              list: [
                "1.人工智能概述 ",
                "2.人工智能产业结构 ",
                "3.人工智能项目开发的基本流程 ",
              ],
            },
            {
              tit: "第2章：机器学习PAI平台基础 ",
              list: [
                "1.阿里云机器学习PAI平台基础 ",
                "2.机器学习PAI-DSW基础",
                "3.机器学习PAI-Designer基础",
                "4.机器学习PAI-EAS基础 ",
              ],
            },
            {
              tit: "第3章：数据处理基础 共3课时",
              list: ["1.数据采集", "2.数据可视化", "3.数据标注 "],
            },
            {
              tit: "第4章：机器学习基础",
              list: [
                "1.机器学习概述 ",
                "2.机器学习经典算法介绍   ",
                "3. 机器学习PAI平台简单实现  ",
              ],
            },
            {
              tit: "第5章：深度学习基础 ",
              list: [
                "1.多层感知机",
                "2.卷积神经网络 ",
                "3.循环神经网络 ",
                "4.生成对抗网络 ",
                "5.机器学习PAI平台简单实现 ",
              ],
            },
            {
              tit: "第6章：计算机视觉基础 共6课时",
              list: [
                "1.计算机视觉概述",
                "2.计算机视觉的基本原理 ",
                "3.图像分类基础 ",
                "4.目标检测基础 ",
                "5.图像分割基础 ",
                "6.实验：计算机视觉技术简单实现 ",
              ],
            },
            {
              tit: "第7章：自然语言处理基础",
              list: [
                "1.自然语言处理基本介绍",
                "2.自然语言处理基础技术详细介绍 ",
                "3.自然语言理解技术介绍与应用",
                "4.自然语言生成技术介绍与应用",
                "5.实验：自然语言处理简单实现",
              ],
            },
            {
              tit: "第8章：智能语音技术基础",
              list: [
                "1.智能语音技术概述 ",
                "2.智能语音技术的处理对象",
                "3.智能语音技术的相关技术 ",
                "4.智能语音交互概述",
                "5.实验：智能语音技术简单实现",
              ],
            },
            {
              tit: "第9章：人工智能其他通用技术",
              list: [
                "1.知识图谱  ",
                "2.机器翻译   ",
                "3.智能机器人   ",
                "4.自动驾驶   ",
                "5.智能开放搜索   ",
                "6.智能推荐 ",
              ],
            },
          ],
        },
      ],
    };
  },
  computed: {
    programCroll: function() {
      return {
        width: this.programData.AboutImage.length * 1180 + "px",
        left: -this.programState * 1180 + "px",
      };
    },
  },
  created() {
    this.getData();
    window.addEventListener("scroll", this.scrollMoveHandle);
    const st = window.localStorage.getItem("topImgSt");
    if (st == undefined || st == null || st == "show") {
      window.localStorage.setItem("topImgSt", "show");
      this.topImgSt = true;
    } else {
      this.topImgSt = false;
    }
    this.objName = "品达物流";
    this.routerLink = "/ai";
  },
  methods: {
    getData() {
      this.$axios
        .post("/api", {
          operationName: "pythonObject",
          variables: {
            id: 4, // sessionStorage.getItem("detailsId"),
          },
          query: pythonObject,
        })
        .then((res) => {
          const data = (this.baseData = res.data.data.pythonObject);
          this.getBaseHeight();
          this.bannerInfo = {
            logo: data.logo,
            objectName: data.objectName,
            objectSubtitle: data.objectSubtitle,
            objectIntroduction: data.objectIntroduction,
            bannerColor: data.bannerColor,
            videoBackground: data.videoBackground,
            videoDesc: data.videoDesc,
            bannerBgImg:
              data.bannerImg && data.bannerImg.length > 0
                ? data.bannerImg[0].url
                : "",
            funDemonstration: data.funDemonstration,
            technicalFile: data.technicalFile,
          };
          this.bannerLabItems = data.webbannerItems;
          this.videoUrl = data.videoUrl;
          this.platIsOpen = data.platIsOpen;
          this.advantageModleTitle = data.advantageModleTitle;
          this.advantageList = data.advantageList;
          this.funIntroductionList = data.funIntroductionList; //功能介绍列表
          this.platformInfo = {
            platColor: data.platColor,
            platTitle: data.platTitle,
            platSubTitle: data.platSubTitle,
            platEnTitle: data.platEnTitle,
            playBgImg: data.playBgImg,
          };
          this.platformData = data.sceneList;
          this.modelData = data.modular;
          this.programData = data.program;
          this.classInfo = {
            classTitle: data.ClassTitle,
            classEnTitle: data.ClassEnTitle,
          };
          this.classData = data.ClassList;
          this.teacherInfo = {
            teachModleTitle: data.TeachModleTitle,
            TeachEnTitle: data.TeachEnTitle,
            teachBgColor: data.TeachBgColor,
            teachBgImg: data.TeachBgImg,
          };
          this.teacherList = data.Teacheres;
          this.topImg = data.topImg.length > 0 ? data.topImg[0].url : "";
          this.butImg = data.botImg.length > 0 ? data.botImg[0].url : "";
          this.acttionInfo = {
            actionlabel: data.actionlabel,
            actionImg: data.actionImg,
          };
          //   功能介绍
          this.funIntroductionTitle = data.funIntroductionTitle; //功能介绍
          //   应用场景数据
          //   this.sceneInfo = {
          this.sceneBgColor = data.sceneBgColor;
          this.sceneBgImg = data.sceneBgImg;
          //   };
          this.sceneModleTitle = data.sceneModleTitle; //应用场景标题
          //   this.scrollHandle()
        });
    },
    cutstr(str, ind) {
      return CutString(str, ind);
    },
    handleClick(val) {
      this.activeName = String(val);
    },
    getBaseHeight() {
      setTimeout(() => {
        this.baseHeight = document.querySelector(".divOffsetParent").offsetTop;
        console.log(this.baseHeight);
      });
    },
    amplifyImg(val) {
      this.amplifyImgUrl = val;
      this.dialogVisible = true;
    },
    scrollMoveHandle() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 显示马上学习导航
      let tag1 = document.querySelector("#scroll1");
      let tag2 = document.querySelector("#scroll2");
      let tag3 = document.querySelector("#scroll3");
      let tag4 = document.querySelector("#scroll4");
      let tag5 = document.querySelector("#scroll5");
      let tag6 = document.querySelector("#scroll6");
      let tag7 = document.querySelector("#scroll7");
      const showNum = 10;
      const num = -670;
      if (scrollTop >= tag1.offsetTop - showNum) {
        this.scroll1Show = true;
      }
      if (scrollTop >= tag2.offsetTop - showNum) {
        this.scroll2Show = true;
      }
      if (scrollTop >= tag3.offsetTop - showNum) {
        this.scroll3Show = true;
      }
      if (scrollTop >= tag4.offsetTop - showNum) {
        this.scroll4Show = true;
      }
      if (scrollTop >= tag5.offsetTop - showNum) {
        this.scroll5Show = true;
      }
      if (scrollTop >= tag6.offsetTop - showNum) {
        this.scroll6Show = true;
      }
      if (scrollTop >= tag7.offsetTop - showNum) {
        this.scroll7Show = true;
      }

      if (scrollTop >= tag1.offsetTop - num) {
        this.localItemIndex = 0;
      }
      if (scrollTop >= tag2.offsetTop - -600) {
        this.localItemIndex = 1;
      }
      if (scrollTop >= tag3.offsetTop - -620) {
        this.localItemIndex = 2;
      }
      if (scrollTop >= tag4.offsetTop - -620) {
        this.localItemIndex = 3;
      }
      if (scrollTop >= tag5.offsetTop - -600) {
        this.localItemIndex = 4;
      }
      if (scrollTop >= tag6.offsetTop - -580) {
        this.localItemIndex = 5;
      }
      if (scrollTop >= tag7.offsetTop - -580) {
        this.localItemIndex = 5;
      }
    },
    // 鼠标滑过展示二维码
    rwmHover(index) {
      this.showRwm = index;
    },
    //
    goDetailPage(url) {
      if (url && /^http/.test(url)) {
        window.open(url, "_black");
      }
    },
    // 解决方案切换
    checkHandle(ind) {
      this.programState = ind;
    },
    // 解决方案自动滚动
    scrollHandle() {
      if (this.programData) {
        const num = this.programData.AboutImage.length - 1;
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          if (this.programState == num) {
            this.programState = 0;
          } else {
            this.programState++;
          }
        }, 3000);
      }
    },
    stopScroll() {
      clearInterval(this.timer);
    },
    setScroll() {
      this.scrollHandle();
    },
    closeTopImg() {
      window.localStorage.setItem("topImgSt", "unShow");
      this.topImgSt = false;
    },
    handleVideo() {
      this.$trackEvent("视频介绍", "点击", "前端学科");
      let obj = {
        url: this.videoUrl,
      };
      this.$refs.editMenu.dialogFormV(obj);
    },
  },
  beforeDestroy() {
    this.stopScroll();
    window.removeEventListener("scroll", this.scrollMoveHandle);
  },
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
